import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20.794 3.205a.7.7 0 0 1 0 .99L15.98 9.01h3.462a.7.7 0 1 1 0 1.4h-5.152a.7.7 0 0 1-.7-.7V5.131a.7.7 0 1 1 1.4 0v2.89l4.815-4.816a.7.7 0 0 1 .99 0ZM3.86 14.29a.7.7 0 0 1 .7-.7h5.152a.7.7 0 0 1 .7.7v4.579a.7.7 0 1 1-1.4 0v-2.89l-4.815 4.816a.7.7 0 0 1-.99-.99L8.02 14.99H4.559a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
